import React, {Fragment, useEffect, useState} from "react";
import HTTPClient from "../../HTTPClient";
import Header from "../Header";
import Loading from "../Loading";
import Typography from "@material-ui/core/Typography";
import Search from "./Search";
import MeetingTitle from "./MeetingTitle";
import BackButton from "../BackButton";
import {getMessage, loadMessages} from "../../util";

const MeetingSearch = (props) => {

    const [loading, setLoading] = useState(true);
    const [meeting, setMeeting] = useState(null);
    const meeting_id = 'bml90MyO';
    const [representative, setRepresentative] = useState(null);
    const [messages, setMessages] = useState(null);

    HTTPClient.interceptors.response.use(function (response) {
        return response;
    }, function (error) {
        switch (error.response.status) {
            case 401:

                window.location = '/login';

                break;
            default:
                return Promise.reject(error);

        }

    });


    useEffect(() => {
        const loadMeeting = () => {
            HTTPClient({
                method: "get",
                url:
                    process.env.REACT_APP_API_URL +
                    "/meetings/" + meeting_id
            })
                .then(response => {
                    setLoading(false);
                    const data = response.data;

                    //if (JSON.stringify(data) !== JSON.stringify(meeting)) {
                    // really lazy way to compare meetings
                    setMeeting(data);
                    loadMessages(data.messages, (error, messages) => setMessages(messages));

                    //}
                    const open_questions = data.questions.filter(q => {
                        return (q.state === 'open')
                    });
                    if (open_questions.length > 0) {
                        window.location = '/meeting/question/' + open_questions[0].slug;
                    }
                })
                .catch((error) => {
                    setLoading(false);
                });
        }

        const loadMe = () => {
            HTTPClient({
                method: "get",
                url:
                    process.env.REACT_APP_API_URL +
                    "/meetings/" + meeting_id + "/me"
            })
                .then(response => {
                        setRepresentative(response.data);
                    }
                )
                .catch((error) => {

                });
        }

        loadMe();
        loadMeeting();
        const intervalId = setInterval(loadMeeting, 3000);
        return (() => {
            clearInterval(intervalId);
        });
    }, [meeting_id]);

    return (
        <Fragment>
            {loading ? (
                <Loading/>
            ) : ((meeting && representative) ? (
                    <Fragment>
                        <Header messages={messages} user={representative} logo={meeting.logo} meeting={meeting}/>
                        <hr/>

                        <MeetingTitle meeting={meeting}/>

                        <BackButton meeting={meeting} messages={messages} href={"/meeting"}/>

                        <Search meeting={meeting}
                        />

                    </Fragment>
                ) : (
                    <Typography variant="h5" component="h2">
                        <hr/>
                        {getMessage('default', 'meeting_not_found', null)}
                    </Typography>
                )
            )}
        </Fragment>
    );
}

export default MeetingSearch;